import { useParams } from "react-router-dom";
import { EditRunContainer } from "./container";

export const EditRunPane = () => {
  const params = useParams();
  const { id } = params;
  return id ? <EditRunContainer runId={id} /> : <></>;
};
